import { useRef, useEffect } from 'react';

function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    function executeCallback() {
      savedCallback.current();
    }

    if (delay !== null) {
      const intervalId = setInterval(executeCallback, delay);
      return () => clearInterval(intervalId);
    }
  }, [delay]);
}

export default useInterval;
